export default [
  {
    header: 'Configuración',
    action: 'read',
    resource: 'Tech',
  },
  // Devices
  {
    title: 'Dispositivos',
    icon: 'HardDriveIcon',
    children: [
      {
        title: 'Dispositivos',
        route: 'devices',
        action: 'read',
        resource: 'Tech',
      },
      {
        title: 'Modelos',
        route: 'models',
        action: 'read',
        resource: 'Tech',
      },
      {
        title: 'Conexión',
        route: 'connections',
        action: 'read',
        resource: 'Tech',
      },
      {
        title: 'UM',
        route: 'units',
        action: 'read',
        resource: 'Tech',
      },

    ],
  },
  // Places installed devices
  {
    title: 'Sitios',
    route: 'sites',
    icon: 'MapPinIcon',
    action: 'read',
    resource: 'Tech',
  },
  // Users
  {
    title: 'Usuarios',
    icon: 'UsersIcon',
    route: 'users',
  },
]
